import { Navigate } from 'react-router-dom';
import { useFeature, useFeaturesLoading } from '../hooks/useFeature';
import type { FeatureCode } from '../types/features';

interface FeatureGateProps {
  code: FeatureCode;
  children: React.ReactNode;
}

/**
 * Gate a route or component behind a feature flag.
 * Redirects to dashboard if the feature is not enabled.
 * Shows nothing while loading to prevent flash.
 */
export function FeatureGate({ code, children }: FeatureGateProps) {
  const isEnabled = useFeature(code);
  const isLoading = useFeaturesLoading();

  if (isLoading) return null;
  if (!isEnabled) return <Navigate to="/" replace />;

  return <>{children}</>;
}
